export default {
  id: '',
  code: '',
  name: '',
  discountPrice: '',
  discountPercent: '',
  isSubscriptionOrder: null,
  __typename: 'CheckoutCoupon'
};
